import Vue from 'vue'

export {
  alert,
  confirm,
  toast,
  loading
}

function alert (...args) {
  let n = args.length - 1
  let onHide = typeof args[n] === 'function' ? args[n--] : null
  let content = args[n--]
  let title = n >= 0 ? args[n] : ''
  Vue.$vux.alert.show({title, content, onHide})
}

function confirm (...args) {
  let n = args.length - 1
  let onConfirm = typeof args[n] === 'function' ? args[n--] : null
  let onHide = null
  if (typeof args[n] === 'function') {
    onHide = onConfirm
    onConfirm = args[n--]
  }
  let content = args[n--]
  let title = n >= 0 ? args[n] : ''
  Vue.$vux.confirm.show({title, content, onConfirm, onHide})
}

function _toast (type, text) {
  Vue.$vux.toast.show({type, text})
}

const toast = {
  i (text) {
    _toast('text', text)
  },
  w (text) {
    _toast('warn', text)
  },
  s (text) {
    _toast('success', text)
  },
  e (text) {
    _toast('cancel', text)
  }
}

const loading = {
  show (text) {
    Vue.$vux.loading.show({text})
  },
  hide () {
    Vue.$vux.loading.hide()
  }
}




// WEBPACK FOOTER //
// ./src/utils/dlg.js